import IndustryPageTemplate from "./IndustryPageTemplate";
import { contractorsData } from "@/data/contractors";

export default function ContractorsPage() {
  return <IndustryPageTemplate data={contractorsData} />;
}
